export default __webpack_public_path__ + "static/sdfcu-282953663740efbaea054d5b521106ab.mp4";